<template>
<div>
	<b-navbar class="submenu">
		<b-container>
			<b-navbar-brand href="#">Customer Admin</b-navbar-brand>
			<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
			<b-collapse id="nav-collapse" is-nav>
				<b-navbar-nav>
					<!-- <a href="#" @click="onLoad()" v-if="article">Reload</a> -->
				</b-navbar-nav>
			</b-collapse>
		</b-container>
	</b-navbar>
	<div id="content">
		<div class="row">
			<div class="col-md-3">
				<div class="row mb-1" v-for="c in customers" :key="c.id">
					<b-button @click="selectCustomer(c)">{{c.person.firstName}} {{c.person.lastName}}</b-button>		
				</div>							
			</div>
			<div class="col-md-8 m-3 mt-0" v-if="customer">
				<div class="row mb-2">
					<h4>{{customer.id}}</h4>
				</div>
				<div class="row mb-2">
					<div class="col-md-4">
						First Name: <b-form-input class="mb-2" v-model="customer.person.firstName"></b-form-input>
					</div>
					<div class="col-md-4">
						Last Name: <b-form-input class="mb-2" v-model="customer.person.lastName"></b-form-input>
					</div>
					<div class="col-md-4">
						Email: <b-form-input class="mb-2" v-model="customer.person.email"></b-form-input>
					</div>
				</div>
				<h4>FactCard</h4>
				<table class="table table-striped table-borderless table-sm">
					<tr v-for="(v, p) in customer.factCard" :key="p">
						<td>{{p}}</td> <td><b-form-input class="mb-2" v-model="customer.factCard[p]"></b-form-input></td>
					</tr>
				</table>
				
			</div>
		</div>
	</div>
</div>
</template>
<script>
export default {
  name: 'Stats',
  data() {
	return{
		customers: null,
		customer: null
	}
  },
  methods: {
	getStats: function(){
		this.$http.get(this.$config.ApiUri + "/Customers")
			.then((result) => {
				this.customers = result.data;
			}
		)
	},
	onLoad() {
		// if (this.$config.Prod == false) {
		// 	this.getStats();
		// } else {
		// 	alert("Nope. No chance.");
		// }
	},
	selectCustomer(c){
		this.customer = c;
		this.$http.get(this.$config.ApiUri + "/Customers/" + c.id)
			.then((result) => {
				this.customer = result.data;
			}
		)
	}
  },
  mounted: function() { this.onLoad(); }
}
</script>